import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
  TableStyle,
} from '../../resources/styling/appStyle';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import {
  Grid,
  Chip,
  Paper,
  InputBase,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { AppButton } from '../../resources/styling';
import { colors } from '../../resources/theme/colors';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 3,
};

const { mandy, pictonBlue } = colors;

function SearchResult() {
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(''); // Search query state

  if (error) {
    return (
      <Typography variant='h6' color='error' align='center'>
        {error}
      </Typography>
    );
  }

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <Grid container>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <h3>Trust Name</h3>
            </Grid>
          </Grid>
          <Grid container mt={2} columnSpacing={1.5}>
            <Grid item xs={12} lg={3} md={3} sm={4}>
              <Paper
                variant='outlined'
                sx={{ p: '0px 4px', display: 'flex', alignItems: 'center' }}
              >
                <IconButton type='button' sx={{ p: '7px' }} aria-label='search'>
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ flex: 1 }}
                  placeholder='Enter keyword'
                  label='Search'
                  value={searchQuery}
                  //onChange={handleSearch}
                />
              </Paper>
            </Grid>
          </Grid>

          <div>
            <Grid container mt={2}>
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <TableStyle>
                  <Paper>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>School Name</TableCell>
                            <TableCell>School URN</TableCell>
                            <TableCell>Account Holder Email</TableCell>
                            <TableCell>Products</TableCell>
                            <TableCell>Live Surveys</TableCell>
                            <TableCell>Draft Surveys</TableCell>
                            <TableCell>Completed Surveys</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>Welbee School One</TableCell>
                            <TableCell>00000</TableCell>
                            <TableCell>schoolone@welbee.co.uk</TableCell>
                            <TableCell>
                              <Stack direction='row' spacing={0.5}>
                                <Chip
                                  label='Staff Wellbeing'
                                  className='staff-chip'
                                  size='small'
                                />
                                <Chip
                                  label='Staff Insight'
                                  className='student-chip'
                                  size='small'
                                />
                                <Chip
                                  label='Student Insight'
                                  className='parent-chip'
                                  size='small'
                                />
                                <Chip
                                  label='Parent Insight'
                                  className='insight-chip'
                                  size='small'
                                />
                              </Stack>
                            </TableCell>
                            <TableCell>02</TableCell>
                            <TableCell>02</TableCell>
                            <TableCell>02</TableCell>
                            <TableCell>
                              <Stack direction='row' spacing={0.5}>
                                <AppButton
                                  //onClick={() => handleDelete(row.id)}
                                  color={pictonBlue}
                                >
                                  Detail
                                </AppButton>
                                <AppButton
                                  //onClick={() => handleDelete(row.id)}
                                  color={mandy}
                                >
                                  Delete
                                </AppButton>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </TableStyle>
              </Grid>
            </Grid>
          </div>
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>
  );
}
export default withRouter(SearchResult);
